import type { ReposicionMediaPort } from '../../domain/ports/ReposicionPorts.ts';
import type { ImageCompressionOptions, ImageCompressionPort } from '@src/modules/platform/local-media/domain/ports/ImageCompressionPort.ts';
import type { LocalMediaBlobPort } from '@src/modules/platform/local-media/domain/ports/LocalMediaBlobPort.ts';
import { CanvasImageCompressionAdapter } from '@src/modules/platform/local-media/infrastructure/driven/CanvasImageCompressionAdapter.ts';
import { IndexedDbLocalMediaBlobAdapter } from '@src/modules/platform/local-media/infrastructure/driven/IndexedDbLocalMediaBlobAdapter.ts';

const REPOSICION_FOTO_COMPRESS_OPTS: ImageCompressionOptions = {
  maxEdge: 1280,
  quality: 0.82,
  skipBelowBytes: 160_000,
};

/** Reposición firma/foto blobs via platform local-media ports. */
export class LocalMediaReposicionAdapter implements ReposicionMediaPort {
  constructor(
    private readonly blobs: LocalMediaBlobPort = new IndexedDbLocalMediaBlobAdapter(),
    private readonly compression: ImageCompressionPort = new CanvasImageCompressionAdapter(),
  ) {}

  async put(id: string, blob: Blob): Promise<void> {
    const stored =
      blob.type === 'image/png' ? blob : await this.compression.compress(blob, REPOSICION_FOTO_COMPRESS_OPTS);
    await this.blobs.put(id, stored);
  }

  get(id: string): Promise<Blob | null> {
    return this.blobs.get(id);
  }

  delete(id: string): Promise<void> {
    return this.blobs.delete(id);
  }

  toBase64(blob: Blob): Promise<string> {
    return this.blobs.toBase64(blob);
  }
}
